import React from "react";

export default function MostSearch() {
    const books = [
        { type: 'Roman', title: '1984' },
        { type: 'Science Fiction', title: 'Star wars' },
        { type: 'Fantaisie', title: 'Le Seigneur des Anneaux' },
        { type: 'Thriller', title: 'Da Vinci Code' },
        { type: 'Roman', title: 'Moby Dick' },
        { type: 'Fantaisie', title: 'Harry Potter' },
    ];

    return (
        <>
            <h3 className="text-2xl text-center font-extrabold mb-5">Recherches les plus fréquentes</h3>

            <div className="grid grid-cols-2 gap-4 px-2 w-full">
                {books.map((book, index) => (
                    <div key={index} className="bg-card w-100 flex flex-col items-start border rounded-lg shadow md:flex-row">
                        <div className="flex flex-col justify-between p-4 leading-normal">
                            <p className="mb-2 text-sm tracking-tight">{book.type}</p>
                            <p className="mb-3 text-base font-medium">{book.title}</p>
                        </div>
                    </div>
                ))}
            </div>
        </>
    )
}